import './featured-card.scss';

import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import { Component, Vue, Watch } from 'vue-property-decorator';

import { Touchable } from '../touchable';

export enum States {
    ABORTED = 'aborted',
    PENDING = 'pending',
    READY = 'ready',
}

export interface Featured {
    author: string | Error | null;
    date?: Date;
    description: string;
    headerDate?: Date;
    highlight?: boolean;
    id: string;
    state: string;
    stateLabel: string;
    title: string;
}

@Component({
    components: {
        sTouchable: Touchable,
    },
    props: ['featured', 'rounded'],
    template: require('./featured-card.html'),
})
export class FeaturedCard extends Vue {
    public featured: Featured;
    public rounded: boolean;

    public circleIcon = faDotCircle;
    public state: States = States.PENDING;

    @Watch('featured', { immediate: true, deep: true })
    public onItemChange(featured) {
        this.state = featured ? States.READY : States.PENDING;
    }

    public isReady() {
        return this.state === States.READY;
    }
}
